// product videos: autoplay, muted, looping, no controls, plus a subtle scroll bar
(function () {
  function init() {
    document.querySelectorAll('.pb-vid__row').forEach(function (row) {
      if (row.dataset.pbV) return; row.dataset.pbV = 1;
      var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.25 }) : null;
      row.querySelectorAll('video').forEach(function (v) {
        v.removeAttribute('controls'); v.controls = false;
        v.muted = true; v.defaultMuted = true; v.loop = true; v.autoplay = true;
        v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
        v.setAttribute('disablepictureinpicture', ''); v.disablePictureInPicture = true;
        v.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback nofullscreen');
        v.addEventListener('contextmenu', function (e) { e.preventDefault(); });
        if (io) io.observe(v); else { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
      var bar = document.createElement('div');
      bar.className = 'pb-vid__bar'; bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<i></i>';
      row.parentNode.insertBefore(bar, row.nextSibling);
      var thumb = bar.firstChild;
      var upd = function () {
        var max = row.scrollWidth - row.clientWidth;
        if (max <= 1) { bar.style.display = 'none'; return; }
        bar.style.display = '';
        var w = Math.max(row.clientWidth / row.scrollWidth * 100, 12);
        thumb.style.width = w + '%';
        thumb.style.left = (row.scrollLeft / max * (100 - w)) + '%';
      };
      row.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd(); setTimeout(upd, 600);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
